<template>
  <multi-input
    readonly
    :value="value"
    :prop="prop"
    :label="label"
    :count="count"
    :rules="rules"
    @input="input"
  >
  </multi-input>
</template>

<script>
import debounce from 'lodash/debounce';

import MultiInput from './multi-input';

export default {
  components: {
    MultiInput
  },
  props: {
    value: Array,
    count: [Number, String],
    rules: Array,
    label: String,
    prop: String,
    cap: [Number, String],
    base: {
      type: Number,
      default: 1
    }
  },
  watch: {
    cap() {
      this.computeValue();
    },
    count() {
      this.computeValue();
    }
  },
  methods: {
    compute() {
      if (!this.count) return;
      const values = new Array(this.count);
      if (this.count === 1) {
        values[0] = this.cap * this.base;
      } else {
        const value = Math.round((this.cap * this.base) / this.count);
        for (let i = 0; i < values.length; i++) {
          if (i === values.length - 1) {
            values[i] = Math.round(
              this.cap * this.base - value * (this.count - 1)
            );
          } else {
            values[i] = value;
          }
        }
      }
      this.$emit('input', values);
    },
    input(value) {
      this.$emit('input', value);
    }
  },
  mounted() {
    this.computeValue = debounce(this.compute, 600);
    this.computeValue();
  }
};
</script>
